import React from 'react';

const DocumentSuccessIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      style={{
        height: props.height ? `${props.height}px` : '',
        width: props.height ? `${props.height * 0.75}px` : ''
      }}
      viewBox="0 0 18 24"
    >
      <path fill="#00B080" d="M1 1v23h16.5V8l-7-7H1Z"/>
      <path fill="#004840" fillRule="evenodd" d="M17.498 7.073 10.988.5a1.802 1.802 0 0 0-.446-.323c-.016-.01-.034-.017-.05-.024l-.015-.007A1.677 1.677 0 0 0 9.797 0H1.71C.778 0 0 .755 0 1.688v20.625C0 23.244.778 24 1.71 24h14.602c.933 0 1.665-.755 1.665-1.688V8.262c0-.446-.165-.872-.479-1.189ZM10 1l7 7h-6a1 1 0 0 1-1-1V1Zm6 22a1 1 0 0 0 1-1V8.8h-6.138C9.84 8.8 8.987 7.995 8.987 7V1H2a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h14Z" clipRule="evenodd"/>
      <path fill="#004840" fillRule="evenodd" d="M3 15.5a6 6 0 1 1 12 0 6 6 0 1 1-12 0Zm2.647-.238 1.897 1.796L12.36 12.5l.642.607-5.458 5.17-2.542-2.408.645-.607Z" clipRule="evenodd"/>
    </svg>
  );
};

DocumentSuccessIcon.defaultProps = { height: 24 };
export default DocumentSuccessIcon;
